import React from "react";
import Input from "./wrapperComponents/Input";
import {UseFormRegister} from "react-hook-form/dist/types/form";
import {IconZoom} from "@tabler/icons-react";

interface SearchInputProps {
    name: string;
    register: UseFormRegister<any>;
    label?: string;
    searchBy: (name: any) => void;
    className?: string | undefined;
}

const SearchInput: React.FC<SearchInputProps> = (props) => {
    const search: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        event.preventDefault();
        props.searchBy(props.name)
    }

    // N.B. per intercettare la pressione di un tasto sono disponibili onKeyDown e onKeyUp
    // In questo caso, è assolutamente necessario scegliere onKeyDown, altrimenti potrebbe "girare" prima il submit dell'intero form
    const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (event) => {
        if (event.key === 'Enter' && (!event.ctrlKey && !event.metaKey)) {
            event.preventDefault();
            event.stopPropagation();
            console.log('searchBy', props.name);
            props.searchBy(props.name)
        }
    }

    return (
        <div className={props.className}>
            {props.label && <label htmlFor="email" className="block text-sm font-medium">
                {props.label}
            </label>}
            <div className="mt-1 flex rounded-md shadow-sm">
                <div className="relative flex flex-grow items-stretch focus-within:z-10">
                    <Input
                        type="text"
                        name={props.name}
                        register={props.register}
                        className={`appearance-none block w-full px-3 py-2 border 
                                        rounded-none rounded-l-md shadow-sm placeholder-gray-400
                                        focus:outline-none
                                        focus:ring-blue-500
                                        focus:border-blue-500 sm:text-sm
                                        border-gray-300`}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <button
                    type="button"
                    className="relative -ml-px inline-flex items-center space-x-2 rounded-r-md border border-gray-300 bg-gray-50 px-4 py-2 text-sm font-medium hover:bg-gray-100 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    onClick={search}
                >
                    <IconZoom className="h-6 w-6 text-gray-400" aria-hidden="true"/>
                </button>
            </div>
        </div>
    )
}
export default SearchInput;